import { TableColumnsType, Tag } from "antd";
import moment from "moment";

import { OfferRequestsTableType } from "../../models";
import {
  RequestProgress,
  getRequestProgress,
  requestProgressInfo,
} from "./requestProgress";

const renderProgress = (record: OfferRequestsTableType) => {
  const progress = getRequestProgress(record);
  const { label, color } = requestProgressInfo[progress];

  return (
    <div>
      <Tag color={color} className="whitespace-normal mr-0">
        {progress === "offers" ? `${label} (${record.responseCount})` : label}
      </Tag>
      {progress === "sent" && record.firstSentAt && (
        <div className="text-xs opacity-60 mt-1">
          {record.sentByName ? `Poslao: ${record.sentByName}, ` : ""}
          {moment(record.firstSentAt).format("DD.MM.YYYY HH:mm")}
        </div>
      )}
    </div>
  );
};

export const offerRequestsColumns = () => {
  const columns: TableColumnsType<OfferRequestsTableType> = [
    {
      title: "NASLOV",
      dataIndex: "name",
    },
    {
      title: "Naziv klijenta",
      dataIndex: "client",
    },
    {
      title: "Kreirao",
      dataIndex: ["user", "name"],
      responsive: ["sm"],
    },
    {
      title: "Status",
      width: 230,
      render: renderProgress,
      filters: (
        Object.entries(requestProgressInfo) as [
          RequestProgress,
          { label: string }
        ][]
      ).map(([value, { label }]) => ({ text: label, value })),
      onFilter: (value, record) => getRequestProgress(record) === value,
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "updatedAt",
      width: 190,
      responsive: ["lg"],
      sorter: (a, b) => moment(a.updatedAt).diff(moment(b.updatedAt)),
    },
  ];

  return columns;
};
